__turbopack_context__.v({
  "box": "Checkbox-module__wuZ-pa__box",
  "checkmark": "Checkbox-module__wuZ-pa__checkmark",
  "input": "Checkbox-module__wuZ-pa__input",
  "label": "Checkbox-module__wuZ-pa__label",
});
